import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiGetPayTypes, apiMJiaSubmitOrder } from '../api';
import { LoadingMask, showConfirm, showToast } from '../components/dialog';
import Page from '../components/page';
import Radiobox from '../components/radioBox';
import main from '../main';
import { goodsDetailRequest } from '../redux/goodsDetailReducer';
import { AppStore, GoodsSkuBoListVo } from '../types';
import { payOrder, PayType } from '../utils/pay';
import { dataDetailStatus, formatNumber, parseLocationParams, validateTel } from '../utils/utils';
import { ProtocolType } from './protocolPage';

let accountTypeOptions: Record<string, string> = {
  phone: '手机号',
  qq: 'QQ号',
};

export default function StockGoodsDetailPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [canBack, setCanBack] = useState(false);
  const [shareUserId, setShareUserId] = useState('');
  const [goodsId, setGoodsId] = useState('');
  const [origin, setOrigin] = useState('');
  const goods = useSelector((state: AppStore) => state.goodsDetail[goodsId]);
  // 选择规格
  const [skuActive, setSkuActive] = useState<GoodsSkuBoListVo>();
  // 账号类型
  const [accountType, setaccountType] = useState<string>();
  // 支付方式（按后台支付配置显隐）
  const [payType, setpayType] = useState<string>('');
  const [enabledPayTypes, setEnabledPayTypes] = useState<string[]>([]);
  // 账号
  const [account, setAccount] = useState('');
  const [checkProtocol, setCheckProtocol] = useState(false);
  const inputRef = useRef<any>(null);

  useEffect(() => {
    let { userId: uid, form: origin, goodsId: gid, canBack: cb } = parseLocationParams(location.search);
    if (uid) {
      setShareUserId(uid);
    }
    if (origin) {
      setOrigin(origin);
    }
    if (gid) {
      setGoodsId(gid);
      dispatch(goodsDetailRequest({ id: gid }));
    } else {
      navigate(-1);
    }
    if (cb === 'true') {
      setCanBack(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]); /// eslint-disable-line

  useEffect(() => {
    let list = goods?.result;
    if (list?.goodsSkuBoList) {
      setSkuActive(list?.goodsSkuBoList[0]);
    }
    if (!!list?.accountType) {
      setaccountType(list?.accountType.split(',')[0]);
    }
  }, [goods]);

  // 支付方式按后台支付配置显隐
  useEffect(() => {
    apiGetPayTypes()
      .then((res: any) => {
        let list: string[] = res?.data?.data ?? [];
        setEnabledPayTypes(list);
        setpayType((cur) => (cur && list.includes(cur) ? cur : defaultPayType(list)));
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function defaultPayType(list: string[]) {
    if (!list.length) return '';
    if (main.isWexin && list.includes(PayType.WECHAT)) return PayType.WECHAT;
    if (list.includes(PayType.ALIPAY)) return PayType.ALIPAY;
    return list[0];
  }

  const handleFocus = () => {
    // 或者滚动到指定元素
    inputRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  async function handleSubmitOrder() {
    let detail = goods!.result!;
    if (!skuActive?.supProductCode) {
      return showToast('请选择规格');
    }
    if (!accountType) {
      return showToast('请选择账号类型');
    }
    if (!account) {
      return showToast('请输入账户');
    }
    if (accountType === 'phone' && !validateTel(account)) {
      return showToast('请输入正确的联系电话');
    }
    if (!checkProtocol) {
      let res = await showConfirm({ title: '提示', content: '请阅读并同意《入网》', confirmBtnText: '同意协议' });
      if (res !== 1) return;
    }

    let resMsg = await showConfirm({
      title: '确认订单',
      content: (
        <div className="text-color-3 pl-20 pr-20">
          <div className="d-flex-r mb-10">
            <div className="text-color-6 w-70 text-left">账号类型：</div>
            {accountTypeOptions[accountType!]}
          </div>
          <div className="d-flex-r mb-10">
            <div className="text-color-6 w-70 text-left">账号：</div>
            {account}
          </div>
          <div className="d-flex-r mb-10">
            <div className="text-color-6 w-70 text-left">订购商品：</div>
            {skuActive?.productName}
          </div>
          <div className="text-left">
            请核对手机号/QQ号是否正确，商品<span className="text-color-red">售出概不退换</span>，支付成功后自动发放
          </div>
        </div>
      ),
      confirmBtnText: '确认充值',
    });
    if (!resMsg) return;
    LoadingMask.show('正在提交...');
    let selectedPayType = payType || defaultPayType(enabledPayTypes);
    try {
      let res = await apiMJiaSubmitOrder({
        goodsId: detail.id,
        supProductCode: skuActive?.supProductCode,
        account,
        accountType,
        payType: selectedPayType, //'wechat' ??
        payWay: 'js',
        openId: main.openId, //  'oz7c96307K0P10xOR8Sg87k1Lbk4' ??
        shareUserId,
        pageSource: 'h5',
        orderSource: origin,
      });
      let data = res.data;
      let orderSn = '';
      if (data.code === 200) {
        orderSn = data.data.orderSn ?? '';
        if ((detail.goodsPrice ?? 0) <= 0) {
          showToast('下单成功');
          // 不用支付的订单
          handlePaySuccess(orderSn);
        } else {
          var payRes = await payOrder(selectedPayType, data.data);
          if (payRes.code === 200) {
            // 支付直接成功的
            showToast(payRes.msg);
            handlePaySuccess(orderSn);
          } else if (payRes.code === 300) {
            if (payRes.url && payRes.url.startsWith('http')) {
              window.location.href = payRes.url;
              return;
            }
            const existingDiv = document.getElementById('alipayPayDiv');
            if (existingDiv) {
              document.body.removeChild(existingDiv);
            }
            let div = document.createElement('div');
            div.id = 'alipayPayDiv';
            div.innerHTML = payRes.url;
            div.style.display = 'none';
            document.body.appendChild(div);
            document.forms[0].submit();
          } else if (payRes.code === 500) {
            // 支付失败的
            showToast(payRes.msg ?? '下单失败');
          }
        }
      } else {
        showToast(data.msg ?? '下单失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '提交失败');
    } finally {
      LoadingMask.hide();
    }
  }

  function handlePaySuccess(sn: string) {
    navigate(`/success?orderSn=${sn}&goodsTitle=${detail.goodsTitle}&time=${dayjs().format('YYYY-MM-DD HH:mm:ss')}`);
  }

  function handleToShare() {
    let detail = goods!.result!;
    navigate(`/share`, {
      state: {
        imgUrl: detail.goodsDetailImg ?? '',
        title: detail.goodsTitle ?? '',
        inviteUserId: '',
        goodsId: detail.id,
      },
    });
  }

  let el = dataDetailStatus({ detail: goods });
  if (el) {
    return <Page>{el}</Page>;
  }
  let detail = goods.result!;
  console.log('skuActive', skuActive);
  return (
    <Page className="bg-color-gray" contentClassName="vw-100 vh-100 pos-r">
      <div className="vw-100 vh-100 overflow-hidden pos-r z-0 d-flex-c">
        <div className="flex-1 h-1 overflow-y">
          <img className="bw-100 h-375" src={detail.goodsDetailImg} alt="" />
          <div className="bg-color-white p-10">
            <div className="font-size-16 font-widget-600">{detail.goodsTitle ?? ''}</div>
            <div className="d-flex-r ai-start pt-10">
              <div className="flex-1 d-flex-r flex-wrap">
                {!!detail.goodsTitleTags &&
                  detail.goodsTitleTags!.split(',').map((i, idx) => (
                    <div
                      key={i + idx}
                      className="border-radius-4 bg-color-red-t3 text-color-red font-size-12 ph-5 pv-2 mr-5 mb-5"
                    >
                      {i}
                    </div>
                  ))}
              </div>
              <div className="font-siez-12 text-color-6">销量{detail.virtualSales ?? 0}</div>
            </div>
            <div className="text-color-9 font-size-12">
              {detail.goodsTags ?? ''}
              {!!detail.goodsTags && !!detail.goodsSpac ? '+' : ''}
              {detail.goodsSpac ?? ''}
            </div>
          </div>
          <div className="bg-color-white pt-14 pl-14 pr-14 pb-7 mt-7">
            <div className="font-size-14 mb-7">
              <span className="text-color-red mr-5">*</span>选择规格
            </div>
            {(detail?.goodsSkuBoList ?? []).map((item, idx) => (
              <div
                key={idx}
                className={`ml-10 mr-20 mb-7 line-height-30 border bg-color-gray border-radius-4 pl-10 pr-10 pt-5 pb-5 ${
                  item?.supProductCode === skuActive?.supProductCode && 'border-color-primary text-color-primary'
                }`}
                onClick={() => setSkuActive(item)}
              >
                ¥<span className="ml-2 mr-5">{item?.productSalePrice}</span>
                {item?.productName}
              </div>
            ))}
          </div>
          <div className="bg-color-white p-14 mt-7 d-flex-r ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red mr-5">*</span>账号类型
            </div>
            {(detail?.accountType ?? '').split(',').map((item) => (
              <div
                className={`mr-5 border bg-color-gray border-radius-4 pl-10 pr-10 pt-5 pb-5 ${
                  accountType === item && 'border-color-primary text-color-primary'
                }`}
                onClick={() => setaccountType(item)}
              >
                {accountTypeOptions[item]}
              </div>
            ))}
          </div>

          <div className="mt-7 bg-color-white p-14 d-flex-r ai-center font-size-14">
            <div className="w-100 d-flex-r ai-center">
              <span className="text-color-red mr-5">*</span>账号
            </div>
            <input
              ref={inputRef}
              onFocus={handleFocus}
              className="flex-1 font-size-14"
              placeholder={`请输入${accountTypeOptions[accountType!]}`}
              value={account}
              onChange={(e) => setAccount(e.target.value)}
            />
          </div>
          <div className="d-flex-r ai-center pl-14 pb-14 pt-15 pb-20">
            <Radiobox value={checkProtocol} onChange={(v) => setCheckProtocol(!checkProtocol)} />
            <span className="font-size-12 text-color-6 ml-5" onClick={() => setCheckProtocol(!checkProtocol)}>
              我已阅读并同意上述描述及
            </span>
            <span
              className="font-size-12 text-color-primary ml-5"
              onClick={() => navigate('/protocol?type=' + ProtocolType.net_in)}
            >
              《入网协议》
            </span>
          </div>
          <div className="ml-7 mr-7 mb-10 d-shadow bg-color-white border-radius-4 p-10">
            <div className="mt-5 mb-10 font-size-14 font-widget-600">支付方式</div>
            {enabledPayTypes.length === 0 && <div className="font-size-12 text-color-6">暂无可用支付方式</div>}
            {enabledPayTypes.includes(PayType.WECHAT) && (
              <div
                className="d-flex-r ai-center jc-between font-size-14"
                onClick={() => setpayType(payType === PayType.WECHAT ? '' : PayType.WECHAT)}
              >
                <div className="d-flex-r ai-center">
                  <img className="w-20 h-20 mr-10" src="/pic/icon_share_wechat.png" alt="" />
                  微信支付
                </div>
                <Radiobox value={payType === PayType.WECHAT} onChange={(v) => setpayType(v ? PayType.WECHAT : '')} />
              </div>
            )}
            {enabledPayTypes.includes(PayType.ALIPAY) && (
              <div
                className="d-flex-r ai-center jc-between font-size-14"
                onClick={() => setpayType(payType === PayType.ALIPAY ? '' : PayType.ALIPAY)}
              >
                <div className="d-flex-r ai-center">
                  <img className="w-20 h-20 mr-10" src="/pic/icon_zfb.png" alt="" />
                  支付宝支付
                </div>
                <Radiobox value={payType === PayType.ALIPAY} onChange={(v) => setpayType(v ? PayType.ALIPAY : '')} />
              </div>
            )}
            {enabledPayTypes.includes(PayType.LFT) && (
              <div
                className="d-flex-r ai-center jc-between font-size-14"
                onClick={() => setpayType(payType === PayType.LFT ? '' : PayType.LFT)}
              >
                <div className="d-flex-r ai-center">
                  <img className="w-20 h-20 mr-10" src="/pic/icon_zfb.png" alt="" />
                  龙付通支付
                </div>
                <Radiobox value={payType === PayType.LFT} onChange={(v) => setpayType(v ? PayType.LFT : '')} />
              </div>
            )}
          </div>
          <div className="goods-detail-html" dangerouslySetInnerHTML={{ __html: detail.goodsDetail ?? '' }}></div>
        </div>
        {detail.hideShare ? (
          <div className="bg-color-white p-20 ai-center">
            <div
              className="bw-100 h-40 border-radius-40 goods-detail-right-btn text-color-white text-center"
              onClick={handleSubmitOrder}
            >
              <div className="font-size-16">{formatNumber(detail.goodsPrice ?? 0)}元</div>
              <div className="font-size-10">立即办理</div>
            </div>
          </div>
        ) : (
          <div className="bg-color-white p-20 d-flex-r ai-center">
            <div
              className="d-flex-c ai-center"
              onClick={() => navigate('/?userId=' + shareUserId, { replace: canBack })}
            >
              <img className="w-26 h-26" src={main.pic('icon_goods_list.png')} alt="" />
              <div className="font-size-12">商品列表</div>
            </div>
            <div className="flex-1" />
            <div
              className="lh-40 text-center w-100 h-40 border-radius-tl-40 border-radius-bl-40 goods-detail-left-btn font-size-16 text-color-white"
              onClick={handleToShare}
            >
              分享
            </div>
            <div
              className="w-100 h-40 d-flex-c ai-center jc-center text-center border-radius-tr-40 border-radius-br-40 goods-detail-right-btn text-color-white"
              onClick={handleSubmitOrder}
            >
              <div className="font-size-16">{formatNumber(skuActive?.productSalePrice ?? 0)}元</div>
              <div className="font-size-10">立即办理</div>
            </div>
          </div>
        )}
      </div>
      <div className="pos-a t-0 l-0 r-0 d-flex-r jc-between pv-20 ph-10">
        <div />
        {!detail.hideShare && (
          <div
            className="w-26 h-26 border-radius-20 bg-color-3-t5 d-flex-r ai-center jc-center"
            onClick={handleToShare}
          >
            <img className="w-20 h-20" src={main.pic('icon_export_white.png')} alt="" />
          </div>
        )}
      </div>
    </Page>
  );
}
